<template>
    <q-card
        :inline="inline"
        :class="['card', 'q-ma-sm', {inEdit: inEdit, draggingOver: draggingOver}]"
        :style="style"
        ref="card"
    >
        <q-card-title class="title">
            <div v-if="! inEdit">{{localModel.label}}</div>
            <q-input v-else v-model="localModel.label"></q-input>
        </q-card-title>

        <q-card-media class="media q-pa-md">
            <drop-area
                class="q-pa-md"
                style="position: relative"
                @dropped="dropShort">

                <template
                    v-if="localModel.extension && localModel.extension.shortMovieUrl || localModel.thumbUrl || localModel.audioUrl">
                    Krótki film, obrazek lub audio:
                    <generic-viewer
                        :src="localModel.extension && localModel.extension.shortMovieUrl || localModel.thumbUrl || localModel.audioUrl"/>

                    <q-btn
                        icon="delete"
                        dense
                        flat
                        class="absolute-top-right"
                        style="right: 0px; top: 10px;"
                        @click="removeMedia"/>
                </template>
                <template v-else>
                    Przeciągnij tu krótki film, obrazek lub audio
                </template>
            </drop-area>
        </q-card-media>

        <q-card-main class="main">
            <p v-if="! inEdit" v-html="localModel.description"></p>
            <q-editor
                ref="editor_ref"
                @paste.native="paste"
                v-if="inEdit && localModel.description != null"
                v-model="localModel.description"/>

            <div class="badges q-ma-sm text-right">

                <div v-if="! inEdit">Kategoria: {{categoryName}}</div>
                <category-chooser v-else
                                  :category="localModel.category"
                                  @selected="setCategory"/>

                <q-field label="Minimalny krok">
                    <q-input type="number" v-if="inEdit" v-model="localModel.minStep" placeholder="1-10"></q-input>
                </q-field>

                <q-color placeholder="Kolor tła" format-model="hex" v-model="localModel.backgroundColor" v-if="inEdit"/>

                <group-switcher @change="value => localModel.group = value" :value="localModel.group" :disabled="! inEdit"/>
            </div>

            <drop-area @dropped="badgeDropped" v-if="inEdit">
                <div v-for="badgeId in localModel.badges"
                     :key="badgeId"
                      style="display: inline-block; position: relative;"
                        class="q-ma-sm">
                    <image-viewer
                        v-if="$store.state.RS.badge === 'fetch_done'"
                        :src="$store.getters.badge.find(b => b.badgeId === badgeId).thumbUrl"
                        style="width: 50px; height: 50px"/>
                    <q-btn
                        icon="delete"
                        dense
                        flat
                        class="absolute-top-right"
                        style="right: -20px; z-index: 10"
                        @click="removeBadge(badgeId)"/>
                </div>
                <br v-if="(localModel.badges || []).length"/>
                Przeciągnij tu odznaki
            </drop-area>
            <div v-else>
                <div v-for="badgeId in (localModel.badges || [])"
                     :key="badgeId"
                     style="display: inline-block; position: relative;"
                     class="q-ma-sm">
                    <image-viewer v-if="$store.state.RS.badge === 'fetch_done'"
                                  :src="$store.getters.badge.find(b => b.badgeId === badgeId).thumbUrl"
                                  style="width: 50px; height: 50px"/>
                </div>
            </div>

        </q-card-main>

        <q-card-actions v-if="!inEdit" align="end" class="actions">
            <publish-button :model="localModel" what="optionalTask"/>
            <q-btn flat round icon="file_copy" @click.native="cloneTask">
                <q-tooltip>
                    Wykonaj kopię
                </q-tooltip>
            </q-btn>
            <q-btn flat round icon="edit" @click="$router.push({name: 'task-edit', params: {optionalTaskId: localModel.optionalTaskId}})"/>
            <q-btn flat round icon="delete" @click="confirmAndDelete"/>
        </q-card-actions>

        <q-card-actions v-if="inEdit" align="end" class="actions"
                        @dragover.native.prevent="dragover"
                        @dragleave.native="dragleave"
                        @dragenter.native="dragenter"
                        @drop.native="dropBackground">
            <q-btn flat round icon="delete" @click="confirmAndDelete"/>
        </q-card-actions>
    </q-card>
</template>

<script>
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QField from 'quasar-framework/src/components/field/QField'
    import GenericViewer from './pole/viewers/GenericViewer'
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QChipsInput from 'quasar-framework/src/components/chips-input/QChipsInput'
    import GroupSwitcher from './GroupSwitcher'
    import QColor from 'quasar-framework/src/components/color/QColor'
    import PublishButton from './pole/PublishButton'
    import QToggle from 'quasar-framework/src/components/toggle/QToggle'
    import DropArea from './DropArea'
    import BadgeComponent from './BadgeComponent'
    import ImageViewer from './pole/viewers/ImageViewer'
    import CategoryChooser from './CategoryChooser'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import { pasteCapture } from '../lib/editor-paste'

    export default {
        name: 'OptionalTaskComponent',
        components: {
            QTooltip,
            CategoryChooser,
            ImageViewer,
            BadgeComponent,
            DropArea,
            QToggle,
            PublishButton,
            QColor,
            GroupSwitcher,
            QChipsInput,
            QCard,
            GenericViewer,
            QField,
            QEditor,
            QBtn,
            QIcon,
            QCardActions,
            QCardMain,
            QCardMedia,
            QCardTitle,
        },
        props: ['model', 'editable', 'inEdit', 'inline'],
        methods: {
            paste (evt) {
                pasteCapture(evt, this.$refs.editor_ref);
            },
            removeMedia () {
                this.localModel.extension.shortMovieUrl = this.localModel.audioUrl = undefined;
                this.localModel.thumbUrl = ''
            },
            cloneTask () {
                const optTask = this.localModel

                const optionalTaskId = this.$uuid()

                const model = {
                    ...optTask,
                    optionalTaskId,
                    title: 'Kopia ' + optTask.label,
                    tasklets: (optTask.tasklets || []).map(t => ({
                        ...t,
                        parentId: optionalTaskId
                    })),
                    publicationInformation: undefined,
                }

                this.$store.dispatch('create', {
                    what: 'optionalTask',
                    item: model
                })

            },
            confirmAndDelete () {
                if (! this.localModel.isNew) {
                    this.$q.dialog({
                        title: `Potwierdź usunięcie zadania`,
                        message: `Czy na pewno usunąć zadanie ${this.localModel.label}?`,
                        ok: 'Usuń',
                        cancel: 'Anuluj',
                        position: 'top',
                    }).then(() => {
                        this.$store.dispatch('remove', {
                            what: 'optionalTask',
                            id: this.localModel.optionalTaskId
                        }).then(() => {
                            this.$emit('deleted')
                        })
                    }).catch(() => {

                    })
                } else {
                    this.$emit('deleted')
                }
            },
            dragenter () {

            },
            dragover () {
                if (this.inEdit) {
                    this.draggingOver = true
                }
            },
            dragleave () {
                if (this.inEdit) {
                    this.draggingOver = false
                }
            },
            drop (e) {
                if (this.inEdit) {
                    e.preventDefault()

                    try {
                        const tasklet = JSON.parse(e.dataTransfer.getData('text'))
                        switch (tasklet.type) {
                            case 'video':
                                this.localModel.movieUrl = tasklet.src
                                break;
                        }
                    } catch (ee) {
                        // console.error(ee)
                    }

                    this.draggingOver = false
                }
            },
            dropShort (e) {
                if (this.inEdit) {
                    e.preventDefault()

                    try {
                        const tasklet = JSON.parse(e.dataTransfer.getData('text'))
                        switch (tasklet.type) {
                            case 'video':
                                this.$set(this.localModel, 'extension', {
                                    ...this.localModel.extension || {}
                                })

                                this.$set(this.localModel.extension, 'shortMovieUrl', tasklet.src);

                                break;
                            case 'audio':
                                this.localModel.audioUrl = tasklet.src
                                this.$set(this.localModel, 'extension', {
                                    ...this.localModel.extension || {}
                                })

                                this.$set(this.localModel.extension, 'shortMovieUrl', tasklet.src);
                                this.localModel.thumbUrl = ''
                                break;
                            case 'picture':
                                this.localModel.audioUrl = null
                                this.$set(this.localModel, 'extension', {
                                    ...this.localModel.extension || {}
                                })

                                this.$set(this.localModel.extension, 'shortMovieUrl', tasklet.src);
                                this.localModel.thumbUrl = tasklet.src
                                break;
                        }
                    } catch (ee) {
                        // console.error(ee)
                    }

                    this.draggingOver = false
                }
            },
            dropBackground (e) {
                if (this.inEdit) {
                    try {
                        this.$set(this.localModel, 'backgroundUrl', JSON.parse(e.dataTransfer.getData('text')).urlPath)
                    } catch (ee) {
                        // console.error(ee)
                    }
                }
            },
            fetch () {
                this.$store.dispatch('fetchTask', this.model.optionalTaskId)
            },
            fetchDetailsIfNecessary () {

            },
            badgeDropped (e) {
                let droppedModel;

                try {
                    droppedModel = JSON.parse(e.dataTransfer.getData('text'))
                } catch (ee) {
                    // console.error(ee)
                }

                if (droppedModel && droppedModel.type === 'badge') {
                    if (this.localModel.badges === undefined) {
                        this.$set(this.localModel, 'badges', [])
                    }

                    if (this.localModel.badges.indexOf(droppedModel.badgeId) === -1) {
                        this.localModel.badges.push(droppedModel.badgeId)
                    }
                }
            },
            removeBadge (badgeId) {
                this.localModel.badges = this.localModel.badges.filter(id => id !== badgeId)
            },
            setCategory (e) {
                this.$set(this.localModel, 'category', e)
            }
        },
        data () {
            return {
                draggingOver: false,
                isNew: false,
            }
        },
        mounted () {
            this.fetchDetailsIfNecessary()
        },
        watch: {
            bgr (value) {
                if (value) {
                    this.localModel.backgroundColor = undefined
                }
            },
            bgrColor (value) {
                if (value) {
                    this.localModel.backgroundUrl = undefined
                }
            },
        },
        computed: {
            bgr () {
                return this.localModel.backgroundUrl
            },
            bgrColor () {
                return this.localModel.backgroundColor
            },
            localModel () {
                return this.$store.state.tasks.find(t => t.optionalTaskId === this.model.optionalTaskId)
                    || this.model
            },
            fullModel () {
                return this.$store.state.tasks.find(t => t.optionalTaskId === this.model.optionalTaskId)
            },
            style () {
                let value = ''

                if (this.localModel && this.localModel.backgroundUrl) {
                    value += `background: url(${this.$store.state.MEDIA_PREFIX_FOR_IMG + this.localModel.backgroundUrl}); background-size: cover; `
                }

                if (this.localModel && this.localModel.backgroundColor) {
                    value += `background-color: ${this.localModel.backgroundColor}; `
                }

                return value
            },
            categoryName () {
                if (this.localModel.category) {
                    const c = this.$store.getters.category.find(c => c.category === this.localModel.category)
                    if (c) {
                        return c.label
                    }

                    return ''
                }
            }

        },
    }
</script>

<style scoped lang="scss">
    .card {
        .actions {
            background: gainsboro;
        }

        border-radius: 20px;
    }

    .card:not(.inEdit) {
        width: 350px;
        /*height: 500px;*/
        overflow: hidden;
        position: relative;

        .media {

        }

        .main {

        }
    }

    .card.inEdit {
        width: 350px;
        position: relative;

        .media {

        }

        .main {

        }

        &.draggingOver {
            border: 1px solid red;
        }
    }

</style>
